var map = {
	"./affektiv.json": 872,
	"./kognitiv.json": 775,
	"./psychomotorisch.json": 420,
	"./saechsischer_lehrplan.json": 806
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 415;
module.exports = webpackAsyncContext;